module.exports = __webpack_public_path__ + "img/horizontal_3_4_4.8308cfda.png";